export default "__VITE_ASSET__okKtxEgY__"